var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ad-slot-preview-row"},[_c('div',{staticClass:"ad-slot-preview-row__content"},[_vm._t("default")],2),(_vm.url)?_c('AdDisplayPreviewButton',{attrs:{"url":_vm.url,"variant":"icon"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }